"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit = _interopRequireDefault(require("lodash/omit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var className = function className(props) {
  return (0, _classnames.default)('Link', {
    'Link--primary': props.category === 'primary',
    'Link--warning': props.category === 'warning',
    'Link--danger': props.category === 'danger',
    'Link--success': props.category === 'success',
    'Link--classic': props.category === 'classic'
  }, {
    'Link--no-decoration': props.underlined === 'none',
    'Link--underlined': props.underlined === 'always'
  }, props.className);
};

var Link = function Link(props) {
  var href = props.href,
      children = props.children,
      component = props.component;

  if (component) {
    return _react.default.createElement(component, _objectSpread({}, (0, _omit.default)(props, ['component', 'category', 'underlined']), {
      className: className(props)
    }), children);
  }

  return _react.default.createElement("a", _extends({}, (0, _omit.default)(props, ['component', 'category', 'underlined']), {
    className: className(props),
    href: href
  }), children);
};

var _default = Link;
exports.default = _default;